/**
 * Display-only formatting helpers (backend precision is unaffected).
 */
export const formatMultiplier = (n: number | null | undefined): string => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '—';
  return `${num.toFixed(2)}x`;
};

/** e.g. 1336.1217 → "~1,336 shares". */
export const formatShares = (n: number | null | undefined): string => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '~0 shares';
  return `~${Math.round(num).toLocaleString()} shares`;
};

/** Bare rounded share count, e.g. 1336.1217 → "1,336". Use in "X of Y shares". */
export const formatSharesBare = (n: number | null | undefined): string => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0';
  return Math.round(num).toLocaleString();
};

/** Exact 2dp for trade slips and LMSR buy/sell panels (matches on-screen ZAR / payout). Not for list overviews. */
export const formatSharesExact2 = (n: number | null | undefined): string => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0.00';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatSharesExact2Label = (n: number | null | undefined): string =>
  `${formatSharesExact2(n)} shares`;

/**
 * ZAR amount per share for consumer UI (exactly 2 decimal places).
 * Calculations and API payloads should keep full precision; use this only when rendering.
 */
export function formatSharePriceZar(n: number | null | undefined): string {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0.00';
  return num.toFixed(2);
}
